import PropTypes from "prop-types";
import React, { useContext } from "react";
import i18n from "~/assets/js/Helpers/i18n";
import QuantityConfigurator from "~/assets/js/components/QuantityConfigurator";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import { calculateDressingDisplayPrice } from "~/assets/js/Format";
import {
    ACTIONS,
    ITEM_TYPE,
    UPDATE_TYPE,
    ProductsDetailsContext,
} from "../../ProductsProvider";
import ClimateDetails from "~/assets/js/components/ClimateDetails";

const Dressing = ({ dressing, firstDressingFree }) => {
    const displayFreeDressing = firstDressingFree && dressing.quantity === 1;
    const { updateProductState, state, isSauceProduct } = useContext(
        ProductsDetailsContext
    );
    const { isDesktop } = useViewport();

    const displayPrice = calculateDressingDisplayPrice(
        dressing,
        state.dressings
    );

    const increment = () => {
        const data = {
            product_id: dressing.product_id,
            update: UPDATE_TYPE.INCREMENT,
            itemType: ITEM_TYPE.DRESSINGS,
        };

        updateProductState({ type: ACTIONS.UPDATE, payload: data });
    };

    const decrement = () => {
        const data = {
            product_id: dressing.product_id,
            itemType: ITEM_TYPE.DRESSINGS,
        };

        if (dressing.quantity === 1) {
            return updateProductState({ type: ACTIONS.REMOVE, payload: data });
        }

        data.update = UPDATE_TYPE.DECREMENT;
        updateProductState({ type: ACTIONS.UPDATE, payload: data });
    };

    return (
        <div className="dressing">
            <div className="dressing__top">
                <img
                    className="dressing__top__img"
                    src={dressing.image}
                    alt={dressing.name}
                />
                <div className="dressing__top__heading">
                    <p className="dressing__top__heading__name">
                        {dressing.name}
                    </p>
                    <div className="dressing__top__heading__calories">
                        <ClimateDetails
                            climateDetails={dressing.details}
                            itemQuantity={dressing.quantity}
                        />
                    </div>
                    {isDesktop && (
                        <div className="dressing__bottom__price">
                            {displayFreeDressing ? (
                                <p className="dressing__bottom__price__complementary">
                                    {isSauceProduct
                                        ? i18n.t("sauces.firstSauceFree")
                                        : i18n.t("dressings.firstDressingFree")}
                                </p>
                            ) : (
                                `+ ${displayPrice}`
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className="dressing__bottom">
                {!isDesktop && (
                    <div className="dressing__bottom__price">
                        {displayFreeDressing ? (
                            <p className="dressing__bottom__price__complementary">
                                {isSauceProduct
                                    ? i18n.t("sauces.firstSauceFree")
                                    : i18n.t("dressings.firstDressingFree")}
                            </p>
                        ) : (
                            `+ ${displayPrice}`
                        )}
                    </div>
                )}
                <QuantityConfigurator
                    quantity={dressing.quantity}
                    increment={increment}
                    decrement={decrement}
                />
            </div>
        </div>
    );
};

Dressing.propTypes = {
    dressing: PropTypes.object,
    firstDressingFree: PropTypes.bool,
};

export default Dressing;
